const GridStyle = theme => ({
  grid: {
    margin: "0 -15px",
    width: "calc(100% + 30px)"
  },
  gridItem: {
    padding: "0 15px !important"
  }
});

export default GridStyle;
